export default "__VITE_ASSET__D7$mrVPy__"